import { render, staticRenderFns } from "./CompnayTestimonial.vue?vue&type=template&id=4a9afd8a&scoped=true&"
import script from "./CompnayTestimonial.vue?vue&type=script&lang=js&"
export * from "./CompnayTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./CompnayTestimonial.vue?vue&type=style&index=0&id=4a9afd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9afd8a",
  null
  
)

export default component.exports